<template>
  <div class="index">
      <div class="index_swiper">
          <!-- <img class="swiper_img" src="~@/assets/bg1.jpg"> -->
          
           <!-- <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(vo,i) of indexlist" :key="i">
                    <img class="swiper_img" :src="$uploadurl + vo.url">
                </div>
                
            </div>

          <div class="swiper-pagination"></div>

          <div class="swiper-button-next swiper-button-white"></div>
          <div class="swiper-button-prev swiper-button-white"></div>

          </div> -->
      
        

          <swiper ref="mySwiper" :options="swiperOptions" v-if="indexlist.length != 0">
              <swiper-slide v-for="(vo,i) of indexlist" :key="i">
                  <img class="swiper_img" :src="$uploadurl + vo.url">
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
      


          <top />



      </div>
      
      <div class="index_more">
          <div class="list">
              <div class="content">
                <div class="img"></div>
                <div class="num">1</div>
                <div class="border"></div>
                <div class="title">七个“一”，成就“七彩”人生</div>
              </div>
          </div>
          <div class="list">
            <div class="content">
              <div class="img"></div>
              <div class="num">17<div class="more">+</div></div>
              <div class="border"></div>
              <div class="title">中一广告策划成立至今已17年</div>
            </div>
          </div>
          <div class="list">
            <div class="content">
              <div class="img"></div>
              <div class="num">100<div class="more">+</div></div>
              <div class="border"></div>
              <div class="title">自有优秀团队，专业人才100多人</div>
            </div>
          </div>
          <div class="list">
            <div class="content">
              <div class="img"></div>
              <div class="num">300<div class="more">+</div></div>
              <div class="border"></div>
              <div class="title">客户遍布各行业，现有300品牌合作商</div>
            </div>
          </div>
      </div>

      <search />

      
      

      <div class="fw">
          <div class="top_text_img">
            <img src="~@/assets/wz.png">
            <div class="title">
                <span class="one">中一</span>
                <span class="two">服务项目</span>
            </div>
            <div class="l_title">
                贴近客户 崇尚行动
            </div>
          </div>
          
          <div class="bottom_img">
              <img class="case1" src="~@/assets/case1.png" data-aos="fade-up" data-aos-offset="300">
              <img class="case2" src="~@/assets/case2.png" data-aos="fade-up" data-aos-offset="400">
              <img class="case3" src="~@/assets/case3.png" data-aos="fade-up" data-aos-offset="500">
          </div>
      </div>


      <div class="fw casebg">
          <div class="top_text_img">
            <img src="~@/assets/case_wz.png">
            <div class="title">
                <span class="one">中一</span>
                <span class="two">案例展示</span>
            </div>
            <div class="l_title">
                分布中山、佛山、江门   2000+策划经验   100+行业方案  
            </div>
          </div>
          
          <div class="case_content">
              <div class="content">
                <div class="case_option">
                    <div class="left"></div>
                    <div class="list" :class="caseid == 0 ? 'active':''" @click="getcase(0)">
                        <span class="name">活动策划</span>
                        <span class="border"></span>
                    </div>
                    <div class="list" :class="caseid == 9 ? 'active':''" @click="getcase(9)">
                        <span class="name">中山风景</span>
                        <span class="border"></span>
                    </div>
                    
                </div>
              </div>

              <div class="case_list">
                  <div class="list" v-for="(vo,i) of caselist.slice(0,8)" :key="i">
                      <img :src="$uploadurl + vo.img">
                      <div class="name">{{vo.name}}</div>
                  </div> 
                  
              </div>

          </div>
      </div>

      <div class="fw">
          <div class="top_text_img">
            <img src="~@/assets/for_one.png">
            <div class="title">
                <span class="one">选择中一</span>
                <span class="two">四大理由</span>
            </div>
            <div class="l_title">
                相信我是您的最佳选择，选择我
            </div>
          </div>
          
          <div class="bottom_content">
              <div class="list">
                  <div class="top_title">资深经验 服务全面</div>
                  <div class="border"></div>
                  <div class="des">【中一广告】是一家拥有17年行业经验的综合性广告服务公司，可为客户提供品牌创意策划、形象设计、产品开发、主题展览、影视宣传及各类大型活动执行等全方位综合性广告服务</div>
                  <img src="~@/assets/liyou1.png">
              </div>
              <div class="list">
                  <div class="top_title">专业到位 深得认可</div>
                  <div class="border"></div>
                  <div class="des">公司汇聚专业及精英服务团队，精准解决客户需求及挖掘潜在价值，深受中山体育局、市政府、银行、伊利等众多知名品牌企业好评认可，保持长期良好合作关系。</div>
                  <img src="~@/assets/liyou2.png">
              </div>
              <div class="list">
                  <div class="top_title">理解客户 快人一步</div>
                  <div class="border"></div>
                  <div class="des">公司蕴含深厚的企业文化，为客户提供专业服务的同时更注重培养团队及员工的能力。坚持“客户第一”的唯一准则，为每位选择、支持、信任我司的客户提供最满意的服务体验。</div>
                  <img src="~@/assets/liyou3.png">
              </div>
              <div class="list">
                  <div class="top_title">覆盖力广 执行力强</div>
                  <div class="border"></div>
                  <div class="des">公司广告业务覆盖广东省各个区域，并在多个城市设有服务站点及专业服务及技术团队，及时解决客户的需求，第一时间为客户提供最高效到位的一站式服务。</div>
                  <img src="~@/assets/liyou4.png">
              </div>
          </div>
      </div>

      <div class="fw teambg">
          <div class="top_text_img">
            <img src="~@/assets/team_title.png">
            <div class="title">
                <span class="one">中一</span>
                <span class="two">团队风采</span>
            </div>
            <div class="l_title">
                专业的水平，丰富的经验，创新的理念，精良的设计制作
            </div>
          </div>
          
          <div class="bottom_team">
              
              <!-- <div class="swiper-container2">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <img src="~@/assets/team_banner1.png">
                    </div>
                    <div class="swiper-slide">
                        <img src="~@/assets/team_banner2.png">
                    </div>
                    <div class="swiper-slide">
                        <img src="~@/assets/team_banner3.png">
                    </div>
                    <div class="swiper-slide">
                        <img src="~@/assets/team_banner4.png">
                    </div>
                    <div class="swiper-slide">
                        <img src="~@/assets/team_banner5.png">
                    </div>
                </div>

              <div class="swiper-pagination2"></div>

              </div> -->

              <swiper ref="mySwiper" class="swiper-container2" :options="swiperOptions2">

                <swiper-slide class="swiper-slide" v-for="(vo,i) of teamlist" :key="i">
                    <img :src="$uploadurl + vo.url">
                </swiper-slide>

            </swiper>

          </div>
      </div>

      <div class="fw">
          <div class="top_text_img">
            <img src="~@/assets/cooperation.png">
            <div class="title">
                <span class="one">中一</span>
                <span class="two">合作客户</span>
            </div>
            <div class="l_title">
                中一与众多品牌保持合作关系，可承办各类型活动
            </div>
          </div>
          
          <div class="bottom_cooperation">
              
              <!-- <div class="swiper-container3">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(vo,i) of brand" :key="i"><img :src="$uploadurl + vo.img"></div>
                </div>

              <div class="swiper-pagination3"></div>

              </div> -->

              <swiper ref="mySwiper" class="swiper-container3" :options="swiperOptions3" v-if="brand.length != 0">
                  <swiper-slide class="swiper-slide" v-for="(vo,i) of brand" :key="i">
                      <img class="swiper_img" :src="$uploadurl + vo.img">
                  </swiper-slide>

                  <div class="swiper-pagination3" slot="pagination"></div>
              </swiper>

          </div>
      </div>

      <div class="fw new_bg">
          <div class="top_text_img">
            <img src="~@/assets/new_title.png">
            <div class="title">
                <span class="one">中一</span>
                <span class="two">文章中心</span>
            </div>
            <div class="l_title">
                聚焦业内新闻，展示公司新闻活动发布
            </div>
          </div>
          
          <div class="bottom_news">
              <div class="list" data-aos="fade-up" data-aos-offset="500">
                  <div class="name">案例展示</div>
                  <div class="news_content">
                      <div class="news_one">
                          <img :src="$uploadurl + anlilist[0].img">
                          <div class="right">
                            <div class="news_title">{{anlilist[0].name}}</div>
                            <div class="news_des">{{anlilist[0].des}}</div>
                          </div>
                      </div>
                      <div class="news_list" v-for="(vo,i) of anlilist.slice(1,5)" :key="i"><span>· </span>{{vo.name}}</div>

                  </div> 
              </div>
              <div class="list" data-aos="fade-up" data-aos-offset="500">
                  <div class="name">公司新闻</div>
                  <div class="news_content" v-if="newlist.length != 0">

                      <div class="news_one">
                          <img :src="$uploadurl + newlist[0].img">
                          <div class="right">
                            <div class="news_title">{{newlist[0].name}}</div>
                            <div class="news_des">{{newlist[0].des}}</div>
                          </div>
                      </div>

                      <div class="news_list" v-for="(vo,i) of newlist.slice(1)" :key="i"><span>· </span>{{vo.name}}</div>

                  </div> 
              </div>
              <div class="list" data-aos="fade-up" data-aos-offset="500">
                  <div class="name">中山风景</div>
                  <div class="news_content">
                      <div class="news_one">
                          <img :src="$uploadurl + fengjinglist[0].img">
                          <div class="right">
                            <div class="news_title">{{fengjinglist[0].name}}</div>
                            <div class="news_des">{{fengjinglist[0].des}}</div>
                          </div>
                      </div>
                      <div class="news_list" v-for="(vo,i) of fengjinglist.slice(1,5)" :key="i"><span>· </span>{{vo.name}}</div>

                  </div> 
              </div>
          </div>
      </div>


      <bottom />
      <right />
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import AOS from "aos";
import "../../node_modules/aos/dist/aos.css";
import top from '@/components/top'
import search from '@/components/search'
import bottom from '@/components/bottom'
import right from '@/components/right'
export default {
  name: 'Home',
  components: {
      Swiper,
      SwiperSlide,
      top,
      search,
      bottom,
      right
  },
  directives: {
      swiper: directive
  },
  data () {
    return {
      swiperOptions: {
            loop:true,
            observer:true,
            observeParents:true,
            observeSlideChildren:true,
            autoplay: 5000,
            pagination: ".swiper-pagination",
            prevButton:'.swiper-button-prev',
            nextButton:'.swiper-button-next',
        // Some Swiper option/callback...
        },
        swiperOptions2: {
            slidesPerView: 5,
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            observer:true,
            observeParents:true,
            autoplayStopOnlast:true,
            paginationClickable: true,
            pagination: '.swiper-pagination2',
            centerInsufficientSlides: true,
            loopFillGroupWithBlank: true,
        // Some Swiper option/callback...
        },
        swiperOptions3: {
            observer:true,
            observeParents:true,
            slidesPerView: 5,
            slidesPerColumn : 3,
            spaceBetween: 30,
        // Some Swiper option/callback...
        },
        
       search_input:'',
       scroll:'',
       
       brand:[],
       newlist:[],
       indexlist:[],

       caselist:[],
       caseid:0,

       teamlist:[],
      
        anlilist:[],
        fengjinglist:[]
    }
  },
  computed: {
    
  },
  created: function () {
      this.brandinfo()
      this.getnews()
      this.iswiper()
      this.getcase(0)
      this.getteam()

      this.anli()
      this.fengjing()
  },
  mounted() {
      AOS.init();
     // 你也可以在这里设置全局配置
      AOS.init({
        offset: 200,   
        duration: 600,   //持续时间
        easing: 'ease-in-sine',   
        delay: 100
     })
  },
  methods:{
      anli(){
          this.$http.post('/api/casecontent/index',this.$qs.stringify({id:0})).then((res)=>{
              let callback = res.data
              let _this = this
              if(callback.code == 200){
                _this.anlilist = callback.data
              }
          }).catch((error) => {
              console.log('获取失败')
          })
      },
      fengjing(){
          this.$http.post('/api/casecontent/index',this.$qs.stringify({id:9})).then((res)=>{
              let callback = res.data
              let _this = this
              if(callback.code == 200){
                _this.fengjinglist = callback.data
              }
          }).catch((error) => {
              console.log('获取失败')
          })
      },
      getteam(id){
          this.$http.post('/api/index/tbanner').then((res)=>{
              let callback = res.data
              if(callback.code == 200){
                this.teamlist = callback.data
              }
          }).catch((error) => {
              console.log('获取失败')
          })
      },
      getcase(id){
          this.caseid = id
          this.$http.post('/api/casecontent/index',this.$qs.stringify({id:id})).then((res)=>{
              let callback = res.data
              if(callback.code == 200){
                this.caselist = callback.data
              }
          }).catch((error) => {
              console.log('获取失败')
          })
      },
      iswiper(){
          this.$http.get('/api/index/pcbanner').then((res)=>{
              let callback = res.data
              if(callback.code == 200){
                this.indexlist = callback.data
              }
          }).catch((error) => {
              console.log('获取失败')
          })
      },
      brandinfo(){
          this.$http.get('/api/brand/index').then((res)=>{
              let callback = res.data
              if(callback.code == 200){
                  this.brand = callback.data
                  
              }else{
                
              }
          }).catch((error) => {
              console.log('获取失败')
          })
      },
      getnews(){
          this.$http.post('/api/casecontent/index',this.$qs.stringify({id:5})).then((res)=>{
              let callback = res.data
              if(callback.code == 200){
                  this.newlist = callback.data
              }else{
                
              }
          }).catch((error) => {
              console.log('获取失败')
          })
      }
  },
  
}
</script>

<style lang="scss" scoped>
$zycolor:#CF2C2E;
.index_swiper{
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  // .swiper_img{
  //   width: 100%;
  //   height: 100vh;
  // }
}


.swiper-container{
  width: 100vw;
  height: 100vh;
  .swiper-slide{
    width: 100%;
    height: 100vh;
    img{
      width: 100%;
      height: 100%;
    }
  }
}

.swiper-pagination-bullet{
  width: 15px;
  height: 15px;
}
.swiper-pagination-bullet-active{
  background: $zycolor;
}
.swiper-button-next{
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: rgba(13, 13, 13, 0.3);
  right: 4%;
  background-image: url('~@/assets/r_right.png');
  background-size:50%;
}
.swiper-button-prev{
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: rgba(13, 13, 13, 0.3);
  left: 4%;
  background-image: url('~@/assets/b_left.png');
  background-size:50%;
}

.index_more{
  width: 100%;
  height: 300px;
  display: flex;
  
  .list{
    width: 25%;
    height: 100%;
    position: relative;
    cursor: pointer;
    // animation:5s infinite;
    .content{
      width: 100%;
      height: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: absolute;
      top:0;
      left: 0;
      z-index: 99;
      .img{
        width: 40px;
        height: 40px;
      }
      .num{
        font-size: 50px;
        font-weight: bolder;
        margin:30px 0 20px 0;
        position: relative;
        .more{
          font-size: 40px;
          font-weight:100;
          position: absolute;
          top:-20px;
          right:-40px;
        }
      }
      .border{
          width: 40px;
          border:1px solid #A1A1A1;
          margin-bottom: 20px;
      }
    }
    
  }
  @keyframes mymove
  {
    from {top:0;height: 300px;}
    to {top:-10px;height: 320px;}
  }
  .list:nth-child(1){
      .img{
          background: url(~@/assets/qy_h.png) no-repeat;
          background-size:100%;
      }
  }
  .list:nth-child(1):hover{
      .content{
        background:$zycolor;
        color:#fff;
        animation:1s infinite mymove;
        animation-iteration-count:1;
        animation-fill-mode: forwards;
      }
      .img{
          background: url(~@/assets/qy.png) no-repeat;
          background-size:100%;
      }
  }
  .list:nth-child(2){
      .img{
          background: url(~@/assets/gj_h.png) no-repeat;
          background-size:100%;
      }
  }
  .list:nth-child(2):hover{
      .content{
        background:$zycolor;
        color:#fff;
        animation:1s infinite mymove;
        animation-iteration-count:1;
        animation-fill-mode: forwards;
      }
      .img{
          background: url(~@/assets/gj.png) no-repeat;
          background-size:100%;
      }
  }
  .list:nth-child(3){
      .img{
          background: url(~@/assets/td_h.png) no-repeat;
          background-size:100%;
      }
  }
  .list:nth-child(3):hover{
      .content{
        background:$zycolor;
        color:#fff;
        animation:1s infinite mymove;
        animation-iteration-count:1;
        animation-fill-mode: forwards;
      }
      .img{
          background: url(~@/assets/td.png) no-repeat;
          background-size:100%;
      }
  }
  .list:nth-child(4){
      .img{
          background: url(~@/assets/hz_h.png) no-repeat;
          background-size:100%;
      }
  }
  .list:nth-child(4):hover{
      .content{
        background:$zycolor;
        color:#fff;
        animation:1s infinite mymove;
        animation-iteration-count:1;
        animation-fill-mode: forwards;
      }
      .img{
          background: url(~@/assets/hz.png) no-repeat;
          background-size:100%;
      }
  }
}

.search_ico{
  background: url('~@/assets/search.png') no-repeat;
  background-size:100%;
}


.fw{
  overflow: hidden;
  .top_text_img{
    margin:70px 0 30px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .title{
    width: 310px;
    padding:20px 0;
    border-top:1px solid #ebeaea;
    border-bottom:1px solid #ebeaea;
    margin:30px 0 10px 0;
    .one{
      font-weight: bold;
      color: 222;
      font-size: 24px;
    }
    .two{
      font-weight: bold;
      color:$zycolor;
      font-size: 24px;
    }
  }
  .l_title{
    color:#bfbebe;
  }
  .bottom_img{
      display: flex;
      justify-content: center;
      margin-top:70px;
      img{
        box-sizing: border-box;
      }
      .case1{
        margin:130px 10px 0 0;
        width: 400px;
        height: 487px;
      }
      .case2{
        width: 400px;
        height: 555px;
      }
      .case3{
        width: 400px;
        height: 488px;
        margin:70px 0 0 10px;
      }
  }
}

.casebg{
  background: url('~@/assets/case_bg.png') no-repeat;
  padding-bottom: 100px;
}
.ceshi{
  
    // width: 0;
    // height: 0;
    // border: 30px solid transparent;
    // border-bottom:30px solid #aaff7f;
    // border-right: 0;
  
}

.case_content{
    width: 100%;
    padding:0 50px;
    box-sizing: border-box;
    margin-top:60px;
    .content{
        display: flex;
        flex-direction: row-reverse;
    }
    .case_option{
      display: flex;
      // background: $zycolor;
      // width: 1400px;
      align-items:flex-end;
      .left{
        width: 0;
        height: 0;
        border-bottom: 51px solid $zycolor;
        border-left: 51px solid transparent;
        // margin-right: 20px;
      }
      .list{
        width: 200px;
        background: $zycolor;
        color: #fff;
        padding:15px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
      }
      .list:hover{
        font-weight: bold;
        .border{
          position:absolute;
          bottom:7px;
          width:25px;
          height: 2px;
          background: #fff;
          margin-top:10px;
          border-radius: 5px;
        }
      }
      .active{
        font-weight: bold;
        .border{
          position:absolute;
          bottom:7px;
          width:25px;
          height: 2px;
          background: #fff;
          margin-top:10px;
          border-radius: 5px;
        }
      }
    }
    .case_list{
        width: 100%;
        display: flex;
        flex-wrap:wrap;
        .list{
            width: 25%;
            display: flex;
            flex-direction: column;
            cursor: pointer;
            img{
              width: 100%;
              height: 340px;
            }
            .name{
              width: 100%;
              text-align: left;
              padding:15px 20px;
              background: #fff;
              box-sizing: border-box;
            }
        }
        .list:hover{
            .name{
              background: $zycolor;
              color:#fff
            }
        }
    }
}

.bottom_content{
  width: 100%;
  display: flex;
  justify-content: space-around;
  margin-top: 100px;
  margin-bottom: 100px;
  padding:0 100px;
  box-sizing: border-box;
  .list{
    width: 18%;
    height: 600px;
    background: #BDBDBD;
    border-radius: 5px;
    box-shadow: 3px 4px 4px rgba(0, 0, 0, 0.2);
    position: relative;
    padding:20px 15px 0 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    .top_title{
      color:#fff;
      font-size: 26px;
      margin-top:30px;
    }
    .border{
      width: 80px;
      height: 3px;
      border-radius: 5px;
      background: #fff;
      margin:10px 0;
    }
    .des{
      width:250px;
      color: #fff;
      margin-top:20px;
      font-size: 20px;
      text-align: left;
    }
    img{
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      height: 250px;
    }
  }
  .list:hover{
    background: #222;
    .border{
      background: $zycolor;
    }
  }
}

.bottom_team{
  overflow: hidden;
  width: 1200px;
  margin:0 auto;
}
.swiper-container2 {
  width: 100%;
  height: 500px;
  .swiper-slide {
      text-align: center;
      font-size: 18px;
      // background: #222;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      transition: 300ms;
      transform: scale(0.8);
      height: 50vh;
      img{
        width: 300px;
        height: 300px;
        border-radius: 5px;
      }
    }
	.swiper-slide-active,.swiper-slide-duplicate-active{
      transform: scale(1);
      z-index: 99;
      img{
        width: 400px;
        height: 400px;
      }
	}
}
.teambg{
  background: url('~@/assets/team_bg.png') no-repeat;
}
.bottom_cooperation{
  overflow: hidden;
  width: 1200px;
  margin:0 auto 30px auto;

}

.swiper-container3 {
  width: 100%;
  height: 500px;
  padding:1px;
  .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;
      height: calc((100% - 30px) / 4);
      width: 216px;
      margin-right:23px;
      // background: #222;
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      img{
        width: 100%;
        height: 100%;
        border:1px solid #A1A1A1;
      }
  }
	
}

.new_bg{
  background: url('~@/assets/news.png') no-repeat;
}
.bottom_news{
  width: 100%;
  // height: 400px;
  padding-bottom:60px;
  display: flex;
  justify-content: space-around;
  .list{
    background: #fff;
    width: 28%;
    height: 700px;
    padding:15px 30px;
    box-sizing: border-box;
    .name{
      width: 100%;
      height: 130px;
      line-height: 130px;
      color:$zycolor;
      font-size: 24px;
      font-weight: bolder;
    }
    .news_content{
      display: flex;
      flex-direction: column;
      padding:15px 0;
    }
    .news_one{
        display: flex;
        // margin-bottom: 40px;
        padding-bottom: 40px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
        img{
          width: 100px;
          height: 100px;
        }
        .right{
          margin-left: 40px;
          text-align: left;
          display: flex;
          flex-direction: column;
          
        }
        .news_title{
            font-size: 20px;
            font-weight: bold;
        }
        .news_des{
            color: #A1A1A1;
            margin-top:10px;
        }
    }
    .news_list{
      display: flex;
      border-bottom:1px solid #eee;
      padding:15px 0;
      cursor: pointer;
      span{
        margin-right:15px;
      }
    }
    .news_list:nth-child(1){
      border-top:1px solid #eee;
    }
  }
}




</style>
